
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit-refund/agreement",
      function () {
        return require("private-next-pages/credit-refund/agreement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit-refund/agreement"])
      });
    }
  